
import { useState } from 'react';
import { auth } from '../firebase/firebase';
import { requestVerificationCode, verifyEmailCode } from '../ctapi/verificationCodes';

export const useEmailVerification = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const getToken = async () => {
    if (!auth.currentUser) throw new Error('Not authenticated');
    return await auth.currentUser.getIdToken();
  };

  const requestCode = async (email) => {
    setIsLoading(true);
    setError(null);
    try {
      const token = await getToken();
      return await requestVerificationCode(token, email);  
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const verifyCode = async (email, code) => {
    setIsLoading(true);
    setError(null);
    try {
      const token = await getToken();
      return await verifyEmailCode(token, email, code);  
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { requestCode, verifyCode, isLoading, error };
};